import "../stylesheets/style_front_pap";
